import { JourneyReview } from 'api/journey-reviews/requests';

import { ReviewPanelState } from './review-panel-view';

type Input = {
  isRunning: boolean;
  // Landed, but the loading animation hasn't played out yet.
  isSettling: boolean;
  review: JourneyReview | null;
  isInitialLoading: boolean;
};

/**
 * `fetching` is separate from `loading` so the empty state never flashes first.
 * A failed run keeps its structural findings, so `error` means it found nothing.
 */
export const resolveReviewPanelState = ({
  isRunning,
  isSettling,
  review,
  isInitialLoading,
}: Input): ReviewPanelState => {
  const hasFailed = review?.status === 'failed';
  if (isRunning) return 'loading';
  if (hasFailed) return review.findings.length > 0 ? 'results' : 'error';
  if (isSettling) return 'loading';
  if (review) return 'results';
  if (isInitialLoading) return 'fetching';
  return 'empty';
};
